import React, { Component } from "react";
import "./index.css";
import YouTube from 'react-youtube';
export default class AboutSection extends Component {
  render() {
    const opts = {
        playerVars: { // https://developers.google.com/youtube/player_parameters
          autoplay: 0
        },
      };
    return (
      <div id="about">
        <div className="landing-header" style={{ marginTop: "10rem" }}>
          <h1>About</h1>
        </div>
        <div className="about">
        <YouTube
        videoId="Toaz0wVky0A"
        opts={opts}
      />
        </div>
      </div>
    );
  }
}
